import { magentoApi } from "./magentoApi";

// Fetch the finance quote from Originator
export async function fetchFinanceQuote(quoteId, optionId) {
  const response = await magentoApi.get(
    `canon/originator?originator_quote=${quoteId}&option=${optionId}`
  );
  // The response is double encoded.
  return JSON.parse(response);
}
